import { Plus } from "@gravity-ui/icons";
import { Card, Flex, Icon, Spin } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";

import { createPoizonClient } from "../../store/fetchers/createPoizonClient";
import css from "./NewClientWidget.module.scss";
export const NewClientWidget = () => {
  const createClient = useAction(createPoizonClient);
  const [isLoading] = useAtom(createPoizonClient.isLoadingAtom);
  return (
    <div>
      <div onClick={() => !isLoading && createClient()}>
        <Card
          className={css.newClientCard}
          theme="normal"
          view="outlined"
          size="m"
        >
          {isLoading ? (
            <Spin />
          ) : (
            <Flex direction="row" alignItems="center" gap="2">
              <Icon data={Plus} />
              <p>Добавить аккаунт</p>
            </Flex>
          )}
        </Card>
      </div>
    </div>
  );
};
